var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 5.5V0.5H15.5V5.5H8.83333ZM0.5 8.83333V0.5H7.16667V8.83333H0.5ZM8.83333 15.5V7.16667H15.5V15.5H8.83333ZM0.5 15.5V10.5H7.16667V15.5H0.5ZM2.16667 7.16667H5.5V2.16667H2.16667V7.16667ZM10.5 13.8333H13.8333V8.83333H10.5V13.8333ZM10.5 3.83333H13.8333V2.16667H10.5V3.83333ZM2.16667 13.8333H5.5V12.1667H2.16667V13.8333Z",
    fill: "#5144B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboardIcon);
export default __webpack_public_path__ + "static/media/active-dashboard-icon.29048849c2c62ad0a80c60e19ef525aa.svg";
export { ForwardRef as ReactComponent };